
import { JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage } from '@/openapi/order';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Tlpf from '@/components/Tlpf.vue';

@Component({
  components: {
    Tlpf,
  },
})
export default class AppHeaderComponent extends Vue {
  @Prop({ type: Array, required: true })
  fieldImage!: Array<JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage>;

  get showDefaultltHeaderImage(): boolean {
    return !this.fieldImage || this.fieldImage?.length === 0;
  }
}
